import { Modal as ModalBootstrap } from 'react-bootstrap'
import '../../styles/Utils/Modal.css'

function Modal({ displayModal, setDisplayModal, onShow, onHide, header, body, footer }) {

    return (

        <ModalBootstrap
            show={displayModal}
            size="lg"
            onShow={() => onShow()}
            onHide={() => { setDisplayModal(false); onHide() }}>
            <ModalBootstrap.Header closeButton={true}>
                <ModalBootstrap.Title>
                    {header}
                </ModalBootstrap.Title>
            </ModalBootstrap.Header>
            <ModalBootstrap.Body>
                {body}
            </ModalBootstrap.Body>
            <ModalBootstrap.Footer>
                {footer}
            </ModalBootstrap.Footer>
        </ModalBootstrap>

    )

}

export default Modal